import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Button } from "../../components/ui/Button";
import { Icon } from "../../components/ui/Icon";
import { ROUTES } from "../../routes";

export function ProfilePage() {
  const { user, logOut, deleteAccount } = useAuth();
  const navigate = useNavigate();

  const initials = (user?.displayName || user?.email || "V")
    .split(/\s+|@/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");

  async function handleLogOut() {
    await logOut();
    navigate(ROUTES.LOGIN, { replace: true });
  }

  async function handleDeleteAccount() {
    await deleteAccount();
    navigate(ROUTES.LOGIN, { replace: true });
  }

  return (
    <div className="mx-auto flex w-full max-w-[720px] flex-1 flex-col px-5 py-10 lg:px-8">
      <div className="card flex items-center gap-5 p-7">
        <div className="flex h-[72px] w-[72px] items-center justify-center rounded-full bg-[linear-gradient(135deg,#CC9A3E,#D9663C)] font-display text-[26px] font-extrabold text-white">
          {initials || "V"}
        </div>
        <div>
          <h1 className="font-display text-[30px] font-bold tracking-[-0.05em] text-foreground">{user?.displayName || "Profil VinIA"}</h1>
          <p className="mt-1 text-[14px] text-secondary">{user?.email || "Compte connecté"}</p>
          <p className="mt-1 text-[13px] text-tertiary">Plan Studio · membre actif</p>
        </div>
      </div>

      <div className="mt-4 rounded-[24px] border border-border bg-surface p-2">
        {[
          { label: "Compte", value: user?.email || "Connecté" },
          { label: "Langues", value: "FR · EN · DE" },
          { label: "Modules", value: "Studio complet" },
          { label: "Carte publique", value: "Active" },
        ].map((row) => (
          <div key={row.label} className="flex items-center justify-between rounded-[18px] px-4 py-4 hover:bg-foreground/[0.03]">
            <span className="text-[15px] font-semibold text-foreground">{row.label}</span>
            <span className="text-[14px] text-tertiary">{row.value}</span>
          </div>
        ))}
      </div>

      <div className="mt-5 flex max-w-[360px] flex-col gap-3">
        <Button variant="secondary" size="lg" className="w-full" onClick={handleLogOut}>
          Se déconnecter
        </Button>
        <Button
          variant="ghost"
          size="lg"
          className="w-full border border-red-500/30 text-red-500 hover:bg-red-500/10"
          onClick={handleDeleteAccount}
        >
          Supprimer le compte
        </Button>
      </div>
    </div>
  );
}
